import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import TreeMark from "@/components/TreeMark";
import PasswordInput from "@/components/PasswordInput";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const from = location.state?.from || "/dashboard";

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (e) {
      setErr(e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 md:py-24">
      <TreeMark size={56} tone="dark" className="mb-6" />
      <div className="text-xs uppercase tracking-[0.2em] text-[#6B7F62] mb-3">Welcome back</div>
      <h1 className="font-serif text-4xl text-[#2D332D] mb-2">Sign in</h1>
      <p className="text-[#576056] mb-10">Your plan is safely kept. Continue where you left off.</p>

      <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="block text-sm font-medium text-[#2D332D] mb-2">Email</label>
          <input
            data-testid="login-email"
            type="email" className="input" value={email}
            onChange={(e) => setEmail(e.target.value)} required autoFocus
            placeholder="you@example.com"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#2D332D] mb-2">Password</label>
          <PasswordInput
            testId="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="At least 6 characters"
            autoComplete="current-password"
          />
        </div>
        {err && <div data-testid="login-error" className="text-sm text-[#B05A5A] bg-[#B05A5A]/8 border border-[#B05A5A]/25 rounded-xl px-4 py-3">{err}</div>}
        <button data-testid="login-submit" type="submit" className="btn-primary w-full justify-center" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <div className="mt-8 text-sm text-[#576056]">
        New here? <Link to="/register" data-testid="to-register" className="text-[#6B7F62] font-medium hover:underline">Create an account</Link>
      </div>
    </div>
  );
}
